import { classnames as cx } from '@carvana/merch-search/utilities';
import { Clickable } from '@carvana/vdp-components';
import { useContext } from 'react';
import MoreDetailsModalSections from '~/constants/MoreDetailsModalSections';
import ModalContext from '~/contexts/ModalContext';
import { useTileDataContext } from '~/contexts/TileDataContext';
import { usePriceTerms } from '../hooks';

type OwnProps = {
  hasValidTerms: boolean;
};

export default function MonthlyPayment({
  hasValidTerms
}: OwnProps): JSX.Element | null {
  const { tileData } = useTileDataContext();
  const { setMoreDetailsModalOpen } = useContext(ModalContext);
  const { monthlyPayment = 0, hasTerms } = usePriceTerms();

  const hasValidMonthlyPayment = monthlyPayment > 0;

  return hasTerms ? (
    <div
      data-qa="monthly-payment"
      className={cx('flex gap-4', {
        empty: !hasValidMonthlyPayment
      })}
    >
      {!hasValidTerms && <span>est.</span>}
      <Clickable
        data-analytics-id="open-result-tile-modal"
        data-analytics-attributes={JSON.stringify({ clickedSource: 'terms' })}
        onClick={e => {
          e.preventDefault();
          setMoreDetailsModalOpen(true, {
            openTo: MoreDetailsModalSections.PriceDetails,
            vehicle: tileData
          });
        }}
        className="pointer-events-auto self-end underline"
        element="span"
      >
        ${monthlyPayment}/mo
      </Clickable>
    </div>
  ) : null;
}
